export class CarouselData {
  public static cardItem = [
      {
        "data": [
          {"id": "1000",
            "code": "f230fh0g3",
            "name": "Jasvinder Kaur,",
            "designation": "Managed to secure  a job through this scheme!",
            "nameMY": "Jasvinder Kaur,",
            "designationMY": "telah berjaya mendapat pekerjaan menerusi skim ini!",
            "testimonial": "The Place & Train scheme under the PENJANA HRD Corp Initiative provides training and job placement for unemployed graduates, school leavers, and retrenched workers. The programmes are designed to develop skills that are relevant to the needs of the industries.",
            "testimonialMY": "Skim Penempatan & Latihan oleh Inisiatif PENJANA HRDF menawarkan peluang latihan serta penempatan pekerjaan untuk graduan yang menganggur, lepasan sekolah dan pekerja yang diberhentikan.",
            imgUrl: "https://www.youtube.com/embed/6q6Micj8_2I?list=PLNNfr2c5uAmmP_jzn95inOYotmHauCJL_",
          },
          {"id": "1000",
            "code": "f230fh0g3",
            "name": "Tan Geok Kian",
            "designation": " Gerak Insan Gemilang scheme",
            "nameMY": "Tan Geok Kian",
            "designationMY": "Gerak Insan Gemilang di bawah Inisiatif",
            "testimonial": "Born with a disability, Tan Geok Kian did not make that an obstacle for himself to move forward. Choosing to become a swimming coach as a source of income, she had to acquiesce when she had to halt her activities temporarily following the COVID-19 outbreak.",
            "testimonialMY": "Dilahirkan dengan kelainan upaya, Tan Geok Kian tidak menjadikannya sebagai halangan untuk dirinya terus maju ke hadapan. Memilih menjadi jurulatih renang sebagai punca pendapatan, dia terpaksa akur apabila perlu memberhentikan seketika aktivitinya berikutan penularan.",
            imgUrl: "https://www.youtube.com/embed/5pvzZnAbTcI?list=PLNNfr2c5uAmmP_jzn95inOYotmHauCJL_",
          },
          {"id": "1000",
            "code": "f230fh0g3",
            "name": "Hamdan Rohman",
            "designation": " SME Development programme",
            "nameMY": "Hamdan Rohman",
            "designationMY": "Pembangunan PKS",
            "testimonial": "SME companies’ viability has been impacted by the COVID-19 pandemic. Hamdan Rohman, determined to survive and remain relevant in the industry had participated in the SME Development programme under the PENJANA HRD Corp Initiative.",
            "testimonialMY": "Pandemik COVID-19 telah menjejaskan kelangsungan perniagaan usahawan PKS. Nekad untuk terus bertahan, Hamdan Rohman mengambil keputusan untuk mengikuti program di bawah skim Pembangunan PKS melalui Inisiatif PENJANA HRDF.",
            imgUrl: "https://www.youtube.com/embed/QeaW5IM8dNk?list=PLNNfr2c5uAmmP_jzn95inOYotmHauCJL_",
          },
        ]
      }
  ]
  public static skillsItem = [
    {
      "data": [
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Accounting & Finance",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Aviation",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Actuarial or Statistics",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Biotechnology or  Chemistry",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Administration or Clerical",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Computer/Information & Technology",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Audit or Tax",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Creative Design",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Accounting & Finance 5",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Accounting & Finance 2",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
      ]
    }
  ]

  public static slotsItem = [
    {
      "data": [
        {"id": "1000",
        "code": "f230fh0g1",
        "trainerName": "Mohammad Azar",
        "duration" : "1 month",
        "startDate" : "1 Oct 2021",
        "endDate": "30 Oct 2021",
        },
        {"id": "1001",
        "code": "f230fh0g3",
        "trainerName": "Mohammad Azar 2",
        "duration" : "1 month",
        "startDate" : "1 Oct 2021",
        "endDate": "30 Oct 2021",
        },
        {"id": "1001",
        "code": "f230fh0g3",
        "trainerName": "Mohammad Azar 3",
        "duration" : "1 month",
        "startDate" : "1 Oct 2021",
        "endDate": "30 Oct 2021",
        },
      ] 
    }
  ];
  public static stateList = [
    { label: "Select State", label_ms: "Pilih Negeri", value: "" },
    { label: "Johor", label_ms: "Johor", value: "Johor" },
    { label: "Kedah", label_ms: "Kedah", value: "Kedah" },
    { label: "Kelantan", label_ms: "Kelantan", value: "Kelantan" },
    { label: "Kuala Lumpur", label_ms: "Kuala Lumpur", value: "Kuala Lumpur" },
    { label: "Labuan", label_ms: "Labuan", value: "Labuan" },
    { label: "Melaka", label_ms: "Melaka", value: "Melaka" },
    { label: "Negeri Sembilan", label_ms: "Negeri Sembilan", value: "Negeri Sembilan" },
    { label: "Pahang", label_ms: "Pahang", value: "Pahang" },
    { label: "Perak", label_ms: "Perak", value: "Perak" },
    { label: "Perlis", label_ms: "Perlis", value: "Perlis" },
    { label: "Pulau Pinang", label_ms: "Pulau Pinang", value: "Pulau Pinang" },
    { label: "Putrajaya", label_ms: "Putrajaya", value: "Putrajaya" },
    { label: "Sabah", label_ms: "Sabah", value: "Sabah" },
    { label: "Sarawak", label_ms: "Sarawak", value: "Sarawak" },
    { label: "Selangor", label_ms: "Selangor", value: "Selangor" },
    { label: "Terengganu", label_ms: "Terengganu", value: "Terengganu" }
  ];
  public static trainingMode = [
    { label: "Select Mode", label_ms: "Pilih Mod", value: "" },
    // { label: "Classroom", value: "Classroom" },
    { label: "Physical (in-person)", label_ms: "Fizikal (bersemuka)​", value: "Classroom" },
    { label: "Online (live)", label_ms: "Dalam Talian (secara langsung)", value: "ROT_Virtual_Training" },
    // { label: "e-Learning", value: "e-Learning" },
    { label: "Self-Paced (e-learning)", label_ms: "Pembelajaran Kendiri (e-Pembelajaran)​", value: "e-Learning" },
    { label: "Blended / Hybrid", label_ms: "Pembelajaran Teradun / Hibrid", value: "Blended / Hybrid" },
    { label: "Coaching", label_ms: "Bimbingan", value: "Coaching" },
    // { label: "ROT / Virtual Training", value: "ROT_Virtual_Training" }
    
    // { label: "Virtual Learning", value: "Virtual Learning" }
  ];
  public static trainingCertification = [
    { label: "Select Certification", value: "" },
    { label: "Certificate of Attendance", value: "1" },
    { label: "Certificate of Competency", value: "2" },
    { label: "Degree", value: "3" },
    { label: "Diploma", value: "4" },
    { label: "Master", value: "5" },
    { label: "Ph.D.", value: "6" },
    { label: "Professional Certificate", value: "7" }
  ];
  public static courseTypeSelection = [
    { label: "Select Course Type", label_ms: "Pilih Jenis Kursus", value: "" },
    { label: "Young Adults and University Students", label_ms: "Remaja dan Pelajar Universiti", value: "1" },
    { label: "Pre-school Children", label_ms: "Anak-anak Tadika", value: "2" },
    { label: "Teenagers", label_ms: "Remaja", value: "3" },
    { label: "Graduates", label_ms: "Lulusan", value: "4" },
    { label: "Professionals", label_ms: "Profesional", value: "5" },
    { label: "Senior Citizens", label_ms: "Warga Tua", value: "6" }
  ];
  

  public static skillsItemtest = [
    {
      "data": [
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Accounting & Finance",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Aviation",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Actuarial or Statistics",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Biotechnology or  Chemistry",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Administration or Clerical",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Computer/Information & Technology",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Audit or Tax",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Creative Design",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Accounting & Finance 5",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Accounting & Finance 2",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
      ],
      "data2": [
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Accounting & Finance",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Aviation",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Actuarial or Statistics",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Biotechnology or  Chemistry",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Administration or Clerical",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Computer/Information & Technology",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Audit or Tax",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Creative Design",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
        {"id": "1000",
            "code": "f230fh0g3",
            "skillName": "Accounting & Finance 5",
            "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            "skillName2": "Accounting & Finance 2",
            "description2": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor ",
            src: ""
          },
      ]
    },
    
  ]

}

